interface SaveErrorBannerProps {
  onRetry: () => void;
  onDismiss: () => void;
}

export default function SaveErrorBanner({
  onRetry,
  onDismiss,
}: SaveErrorBannerProps) {
  return (
    <div
      role="alert"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-amber-200 bg-amber-50 px-4 py-3 shadow-lg dark:border-amber-500/30 dark:bg-amber-950/90"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-amber-950 dark:text-amber-100">
          Kunne ikke gemme din fremgang på serveren. Tjek forbindelsen — ændringer
          kan gå tabt ved genindlæsning.
        </p>
        <div className="flex shrink-0 gap-2">
          <button type="button" onClick={onRetry} className="btn-primary py-1.5 text-sm">
            Prøv igen
          </button>
          <button type="button" onClick={onDismiss} className="btn-secondary py-1.5 text-sm">
            Luk
          </button>
        </div>
      </div>
    </div>
  );
}
